import { fixLocalDate } from "./dateHelpers";

export function formatDateList(dateInputArray) {
  return dateInputArray
    .map(d => {
      const fixed = fixLocalDate(d.date || d); // obsłuży i stringi, i obiekty { date: ... }
      return `${String(fixed.getDate()).padStart(2, '0')}.${String(fixed.getMonth() + 1).padStart(2, '0')}`;
    })
    .join(", ");
}
